/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the diagonal resolution (√(width² + height²) in pixels) by the diagonal screen size in inches.`)
};

const es_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide la resolución diagonal (√(ancho² + alto²) en píxeles) entre el tamaño diagonal de la pantalla en pulgadas.`)
};

const de_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile die diagonale Auflösung (√(Breite² + Höhe²) in Pixeln) durch die Bildschirmdiagonale in Zoll.`)
};

const nl_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel de diagonale resolutie (√(breedte² + hoogte²) in pixels) door de diagonale schermgrootte in inches.`)
};

const fr_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisez la résolution diagonale (√(largeur² + hauteur²) en pixels) par la taille diagonale de l'écran en pouces.`)
};

const it_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi la risoluzione diagonale (√(larghezza² + altezza²) in pixel) per la dimensione diagonale dello schermo in pollici.`)
};

const pt_br2_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida a resolução diagonal (√(largura² + altura²) em pixels) pelo tamanho diagonal da tela em polegadas.`)
};

const pt_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida a resolução diagonal (√(largura² + altura²) em pixels) pelo tamanho diagonal do ecrã em polegadas.`)
};

const ja_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対角解像度(√(幅² + 高さ²)、単位はピクセル)を、対角の画面サイズ(インチ)で割ります。`)
};

const zh_ppi_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用对角线分辨率（以像素为单位的 √(宽度² + 高度²)）除以屏幕对角线尺寸（英寸）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_faq_a2", locale)
	if (locale === "en") return en_ppi_faq_a2(inputs)
	if (locale === "es") return es_ppi_faq_a2(inputs)
	if (locale === "de") return de_ppi_faq_a2(inputs)
	if (locale === "nl") return nl_ppi_faq_a2(inputs)
	if (locale === "fr") return fr_ppi_faq_a2(inputs)
	if (locale === "it") return it_ppi_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_faq_a2(inputs)
	if (locale === "pt") return pt_ppi_faq_a2(inputs)
	if (locale === "ja") return ja_ppi_faq_a2(inputs)
	return zh_ppi_faq_a2(inputs)
};